"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.autoRenewTokens = exports.renewTokensAndStartTimerAsync = void 0;
const initSession_js_1 = require("./initSession.js");
const initWorker_js_1 = require("./initWorker.js");
const oidc_js_1 = __importDefault(require("./oidc.js"));
const parseTokens_js_1 = require("./parseTokens.js");
const timer_js_1 = __importDefault(require("./timer.js"));
function renewTokensAndStartTimerAsync(oidc, refreshToken, forceRefresh = false, extras = null) {
    return __awaiter(this, void 0, void 0, function* () {
        const updateTokens = (tokens) => { oidc.tokens = tokens; };
        const { tokens, status } = yield oidc.synchroniseTokensAsync(refreshToken, 0, forceRefresh, extras, updateTokens);
        const serviceWorker = yield (0, initWorker_js_1.initWorkerAsync)(oidc.configuration.service_worker_relative_url, oidc.configurationName);
        if (!serviceWorker) {
            const session = (0, initSession_js_1.initSession)(oidc.configurationName, oidc.configuration.storage);
            yield session.setTokens(oidc.tokens);
        }
        if (!oidc.tokens) {
            yield oidc.destroyAsync(status);
            return;
        }
        if (oidc.timeoutId) {
            oidc.timeoutId = (0, exports.autoRenewTokens)(oidc, tokens.refreshToken, oidc.tokens.expiresAt, extras);
        }
        return oidc.tokens;
    });
}
exports.renewTokensAndStartTimerAsync = renewTokensAndStartTimerAsync;
const autoRenewTokens = (oidc, refreshToken, expiresAt, extras = null) => {
    const refreshTimeBeforeTokensExpirationInSecond = oidc.configuration.refresh_time_before_tokens_expiration_in_second;
    return timer_js_1.default.setTimeout(() => __awaiter(void 0, void 0, void 0, function* () {
        const timeLeft = (0, parseTokens_js_1.computeTimeLeft)(refreshTimeBeforeTokensExpirationInSecond, expiresAt);
        const timeInfo = { timeLeft };
        oidc.publishEvent(oidc_js_1.default.eventNames.token_timer, timeInfo);
        yield renewTokensAndStartTimerAsync(oidc, refreshToken, false, extras);
    }), 1000);
};
exports.autoRenewTokens = autoRenewTokens;
//# sourceMappingURL=renewTokens.js.map